<template lang="pug">
.modal-wrapper
  .button-wrapper
    b-button(icon-left="plus" type="is-light" @click="openModal()") Objekt hinzufügen 

  b-modal(v-model="isComponentModalActive"
          has-modal-card
          :full-screen="false" 
          :can-cancel="true")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Mietobjekt auswählen
      section.modal-card-body
        b-table(:data="filteredRentObjects"
                      default-sort-direction="asc"
                      default-sort="date"
                      :checked-rows.sync="checkedRows"
                      checkable
                      hoverable)
          b-table-column(field='code' label='Code' width='40' sortable centered searchable v-slot="props")
            | {{ props.row.code }}
          b-table-column(label='Typ' width='40' sortable, v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObjectType.icon")
              p.icon-name {{props.row.rentObjectType.name}}
          b-table-column(field='name' label='Titel' sortable, v-slot="props")
            | {{ props.row.name }}
      footer.modal-card-foot 
        .button-wrapper.right
          b-button(type="is-primary" @click="selectObjects()") Auswählen
</template>

<script>
export default {
  props: {
    rentObjectTypeUUIDs: {
      type: Array,
      default () {
        return []
      }
    },
    disabledIds: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data() {
    return {
      checkedRows: [],
      isComponentModalActive: false,
    }
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all.filter(r => this.selectedRentObjectTypeIds.includes(r.rentObjectTypeId));
    },
    filteredRentObjects() {
      return this.rentObjects.filter(r => this.disabledIds.includes(r.id) === false)
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    },
    selectedRentObjectTypeIds() {
      const ids = [];
      this.rentObjectTypeUUIDs.forEach(r => {
        const newId = this.rentObjectTypes.find(t => t.uuid === r);
        if (newId) {
          ids.push(newId.id);
        }
      });
      return ids;
    }
  },
  methods: {
    openModal() {
      this.isComponentModalActive = true;
    },
    async selectObjects() {
      this.isComponentModalActive = false;
      this.$emit("selected", this.checkedRows);
    }
  },
  mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.$store.dispatch("rentObjectTypes/findAll");
  }
}
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>